import {
  HTTP_REPORTMANAGERBYDEPTS_FETCHING,
  HTTP_REPORTMANAGERBYDEPTS_SUCCESS,
  HTTP_REPORTMANAGERBYDEPTS_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateReportByDepartToFetching = () => ({
  type: HTTP_REPORTMANAGERBYDEPTS_FETCHING,
});

export const setStateReportByDepartToSuccess = (payload) => ({
  type: HTTP_REPORTMANAGERBYDEPTS_SUCCESS,
  payload,
});

export const setStateReportByDepartToFailed = (payload) => ({
  type: HTTP_REPORTMANAGERBYDEPTS_FAILED,
});

export const clearreportFianlByDepts = () => {
  return async (dispatch) => {
    dispatch(
      setStateReportByDepartToSuccess({
        data: [],
      })
    );
  };
};

export const reportFianlByDepart = (item) => {
  return async (dispatch) => {
    dispatch(setStateReportByDepartToFetching());

    try {
      const result = await httpClient({
        method: "post",
        url: `${server.REPORTMANAGERBYDEPARTMENT_URL}`,
        timeout: 1000 * 30, // Wait for 30 seconds
        data: item,
      });
      // const result = await httpClient.post(
      //   `${server.REPORTMANAGERBYDEPARTMENT_URL}`,
      //   item
      // );
      dispatch(setStateReportByDepartToSuccess(result.data));
    } catch (err) {
      dispatch(setStateReportByDepartToFailed());
    }
  };
};
